export default __webpack_public_path__ + "static/48-fit-68cde6cc0df23ebecc9a6ca2d6af9bbc.png";